import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const AccountInfo = ({account}) => {
    let location = useLocation();
    const [showGreeting, setShowGreeting] = useState<boolean>(false);

    useEffect(() => {
        switch(location.pathname){
            case '/account':
                setShowGreeting(true);
                break;
            default:
                setShowGreeting(false);
                break;
        }
    }, [location])// eslint-disable-line react-hooks/exhaustive-deps

    return (account ?
        <div className='account-select-info' style={{paddingLeft:"25px", alignSelf: "flex-end"}}>
            <div style={{paddingBottom:"5px"}}><b>{showGreeting ? "Welcome, " : ""}{account?.customer?.fullName ?? account?.accountName}</b></div>
            <div>Account Number <b>{account?.accountNumber}</b></div>
            <div> Address&nbsp;
                <b>
                    {account?.services ? account?.services[0]?.serviceAddress?.street : account?.serviceAddress ?? "N/A"}
                </b>
            </div>
        </div>
    : <></>)
};